import { useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, matchPath } from "react-router-dom";
import "../utils/tailwind.css";
import { useStore } from "../utils/context";
import Modal from "../components/modal";
import Const from "../utils/constant";
import cx from "../utils/tailwind-merge";
import GyaankoolLogo from "../assets/images/gyaankoollogo.png";
import Label from "../components/label";

const Sidebar = () => {
  const location = useLocation();

 
  const isActiveTab = (tab) =>
    matchPath({ path: tab, end: true }, location.pathname);

  const { handleLogout } = useStore();
  const [isModalOpen, setIsOpenModal] = useState(false);

  const menu = Const.MENU_ITEMS.PAGES;
  const masterMenu = Const.MENU_ITEMS.MASTER_PAGES;
  const miscMenu = Const.MENU_ITEMS.MISC;

  const handleLogoutClick = () => {
    handleLogout();
  };

  return (
    <div className="w-[16rem] border z-[1000] h-[100%] flex flex-col justify-between fixed pt-2 overflow-scroll pb-[2rem] bg-[#fef5e4] custom-scrollbar">
      <Navbar variant="light" className="flex flex-col">
        <div>
          <img src={GyaankoolLogo} className="w-[100px] h-[30px] object-fill" alt="Login" />
        </div>

        <Modal
          title="Confirm"
          desc="Are you sure you want to logout ?"
          isModalOpen={isModalOpen}
          setIsOpen={setIsOpenModal}
          handleSubmit={handleLogoutClick}
          confirmButtonLabel="Logout"
        />

        <Label label="Screens" className="mt-[9px] mb-1 pt-2 border-t-[1px] text-[16px] pl-3 w-full" />
        {menu.map((item) => {
          const isActive = isActiveTab(item.link);
          return (
            <div key={item.id} className={cx("w-100 px-3 border-l-4 border-l-transparent", isActive && "border-l-[#ffe9b8]")}>
              <Nav className={cx("flex-column w-100 py-[2px]", isActive && "!bg-[#ffe9b8] text-black rounded-[10px]")}>
                <Nav.Link as={Link} to={item.link} className={cx("!flex items-center gap-3 px-3 py-2  text-[#2C2C2C]", isActive && "text-black")}>
                  <span className={cx("w-6 h-6 text-[#2C2C2C]", isActive && "text-black")}>
                    <item.icon size={20}/>
                  </span>
                  {item.label}
                </Nav.Link>
              </Nav>
            </div>
          );
        })}

        <Label label="Masters" className="mt-[9px] mb-1 pt-2 border-t-[1px] text-[16px] pl-3 w-full" />
        {masterMenu.map((item) => {
          const isActive = isActiveTab(item.link);
          return (
            <div key={item.id} className={cx("w-100 px-3 border-l-4 border-l-transparent", isActive && "border-l-[#ffe9b8]")}>
              <Nav className={cx("flex-column w-100 py-[2px]", isActive && "!bg-[#ffe9b8] text-black rounded-[10px]")}>
                <Nav.Link as={Link} to={item.link} className={cx("!flex items-center gap-3 px-3 py-2 !text-[15px] text-[#2C2C2C]", isActive && "text-black")}>
                  <span className={cx("w-6 h-6 text-[#2C2C2C]", isActive && "text-black")}>
                    <item.icon size={20} />
                  </span>
                  {item.label}
                </Nav.Link>
              </Nav>
            </div>
          );
        })}

        <Label label="Miscellaneous" className="mt-[9px] pt-2 border-t-[1px] text-[16px] pl-3 w-full" />
        {miscMenu.map((item) => {
          const isActive = isActiveTab(item.link);
          return (
              <div key={item.id} className={cx("w-100 px-3 border-l-4 border-l-transparent -mt-3", isActive && "border-l-[#ffe9b8]")}>
              <Nav className={cx("flex-column w-100 py-[2px]", isActive && "!bg-[#ffe9b8] text-black rounded-[10px]")}>
                <Nav.Link as={Link} to={item.link} className={cx("!flex items-center gap-3 px-3 py-2 !text-[15px] text-[#2C2C2C]", isActive && "text-black")}>
                  <span className={cx("w-6 h-6 text-[#2C2C2C]", isActive && "text-black")}>
                    <item.icon size={20} />
                  </span>
                  {item.label}
                </Nav.Link>
              </Nav>
            </div>
          );
        })}
      </Navbar>
    </div>
  );
};

export default Sidebar;
